<template>
<span id="change-shipdate-total-units-span" v-if="isVisible()">
  <el-button
    id="btn-change-shipdate"
    type="success"
    plain @click="handleOpen"
    size="mini"
    v-show="displayButton"
  >
    {{ $t('outbound.units.changeShipDate') }}
  </el-button>
  <el-dialog
    :close-on-click-modal="false"
    v-on:open="handleOpen"
    :title="$t('outbound.units.changeShipDate')"
    :visible.sync="dialogVisible"
    width="34%"
    id="change-ship-date-dialog"
    v-on:closed="$emit('close-dialog')"
  >
    <el-form
      :model="changeShipDateForm"
      :rules="formRules"
      ref="changeShipDateForm"
      label-position="right"
      size="mini"
      inline class="text-align-end"
    >
      <el-row>
        <div>
          <span class="change-shipdate-total-units-span">
            {{ $t('outbound.units.totalUnitsChangeShipDate') }} {{ outboundUnits.total }}
          </span>
        </div>
        <el-col class="form-vertical-item">
          <el-form-item :label="$t('outbound.units.newShipDate')" prop="newShipDate">
            <el-date-picker
              v-model="changeShipDateForm.newShipDate"
              format="MM/dd/yyyy"
              :picker-options="shipDatePickerOptions"
              type="date"
              id="changeShipDateForm-new-ship-date"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
      <el-button
        type="primary"
        @click="handleChangeShipDate"
        size="mini"
        class="margin-r-18"
        id="btn-change-ship-date-move"
      >
        {{ $t('common.move') }}
      </el-button>
      <el-button @click="dialogVisible = false" size="mini">{{ $t('common.cancel') }}</el-button>
    </div>
  </el-dialog>
</span>
</template>

<script>
import moment from 'moment';
import { Message } from 'element-ui';
import { mapActions, mapGetters } from 'vuex';
import constants from '@/utils/constants';
import { OUTBOUND_UNITS_CHANGE_SHIP_DATE, OUTBOUND_UNITS_SEARCH } from '@/store/actions';

export default {
  name: 'ChangeShipDateDialog',
  props: {
    displayButton: Boolean,
  },
  computed: {
    ...mapGetters([
      'outboundUnits'
    ])
  },
  data() {
    return {
      dialogVisible: false,
      changeShipDateForm: {
        newShipDate: null
      },
      formRules: {
        newShipDate: [
          { required: true, message: this.$t('outbound.units.newShipDateRequired'), trigger: 'blur' }
        ]
      },
      shipDatePickerOptions: {}
    };
  },
  methods: {
    ...mapActions({
      changeShipDate: OUTBOUND_UNITS_CHANGE_SHIP_DATE,
      search: OUTBOUND_UNITS_SEARCH,
    }),
    handleOpen() {
      this.dialogVisible = true;
      this.changeShipDateForm.newShipDate = null;
      this.shipDatePickerOptions = {
        disabledDate(time) {
          const momentTime = moment(time.getTime());
          return momentTime.isBefore(moment(), 'day');
        }
      };
      this.$nextTick(() => {
        this.$refs.changeShipDateForm.$el[0].focus();
      });
    },
    async handleChangeShipDate() {
      const valid = await this.$refs.changeShipDateForm.validate().catch(() => {});
      if (!valid) {
        return;
      }

      // Close previous messages and show loading
      Message.closeAll();
      const loading = this.$loading(constants.LOADING.CHANGE_SHIPDATE_CONFIG);

      // Call action to changeShipDate
      try {
        await this.changeShipDate(this.changeShipDateForm.newShipDate).catch(() => {});
        await this.search({});
        this.dialogVisible = false;
      } finally {
        loading.close();
      }
    },
    isVisible() {
      const hasUnits = this.outboundUnits.list && this.outboundUnits.list.length > 0;
      const hasChangeShipmentPermission = this.$can(this.permissions.OUTBOUND.CHANGE_SHIP_DATE);
      return hasUnits && hasChangeShipmentPermission;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.change-shipdate-total-units-span {
  text-align: left;

  #btn-change-shipdate {
    margin-right: 10px;
  }
}
</style>
